import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import Toptitle from "../../components/toptitle"

const Construct = () => (
  <Layout>
    <SEO title="採用情報 製造" />
    <div>
      <section className="mx-8 lg:mr-0 lg:ml-auto lg:w-2/3">
        <Toptitle>New Graduate</Toptitle>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <div className="relative left-1/2 right-1/2 w-screen -translate-x-1/2 lg:static lg:left-auto lg:right-auto lg:w-full lg:translate-x-0">
            <StaticImage
              src="../../images/recruit/manu2.png"
              alt="新卒採用について"
              className="w-full"
            />
          </div>
          <h1 className="mt-16 font-mincho text-3xl text-primary">
            採用メッセージ
          </h1>
        </div>
        <div className="mt-8">
          <p className="font-gothic leading-loose">
            株式会社アートマテリアルは、商業施設や建物で使われる内装材を製造している会社です。
            <br />
            工場でつくった製品は実際の店舗や施設に使われ、多くの人が利用する空間の一部になります。
            <br />
            <br />
            仕事は単純な流れ作業ではなく、図面を見て加工方法や手順を考えながら製品をつくります。経験を重ねるほど技術が身につき、自分の手で形をつくり上げていく面白さがあります。
            <br />
            <br />
            私たちが求めているのは、特別な才能ではなく、素直さと責任感です。文系・理系も関係なく、技術や器用さは入社してから身につければ大丈夫です。手に職をつけ、ものづくりの面白さを感じながら成長したい人を歓迎します。
          </p>
          <div className="mt-4 md:flex">
            <StaticImage
              src="../../images/works/ecute/4.jpg"
              alt="製造職の現場"
              className="w-full"
            />
            <StaticImage
              src="../../images/works/ecute/3.jpg"
              alt="製造職の現場"
              className="w-full"
            />
          </div>
          <span className="font-mincho text-xs">納品事例 : エキュート東京</span>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">
            安心して働ける環境
          </h2>

          <div className="mt-8 ">
            <div className="mt-8 font-gothic">
              <h3 className="border-l-4 border-sub pl-2 font-mincho text-xl">
                創業以来21年連続黒字の安定経営
              </h3>
              <p className="mt-4 font-gothic leading-loose">
                創業以来21年間黒字の安定経営を続けています。
                <br />
                業界の中で確かな実績があり、大手ゼネコンをはじめ様々なお客様がいらっしゃいます。
                <br />
                安定した経営は働く人の安心にもつながります。
                <br />
                例えば、
                <ul className="list-inside list-disc  pl-4 ">
                  <li>賞与支給（24年度実績 5ヶ月）</li>
                  <li>定期的な給与改定</li>
                  <li>社会保険・労災完備</li>
                  <li>資格取得支援制度</li>
                  <li>豊富な休日数</li>
                </ul>
                上記はどれも会社の成長とともに充実をはかってまいりました。
                <br />
                今後も一層働きやすい環境構築に努めてまいります。
              </p>
              <h3 className="mt-8 border-l-4 border-sub pl-2 font-mincho text-xl">
                技術者の育成
              </h3>
              <p className="mt-4 font-gothic leading-loose">
                入社後は、ものづくりの基礎から段階的に学び、技術を身につけていきます。
                <br />
                図面の読み方や材料・加工の知識、NC機械の操作、CAM・CADデータ作成など、現場で必要なスキルを一つずつ習得し、ものづくりの本質を理解した技術者を目指してキャリアを積むことができます。
                <br />
                <br />
                一人前の技術者を目指しながらも、仕事は設計・加工・組立といった工程をチームで連携して進めます。その中で、コミュニケーション力や責任感、協力する力も自然と身につき、技術と人間力の両方を成長させることができます。
                <br />
                <br />
                社内だけで完結する技術ではなく、
                <span className="text-primary">
                  広く通用する力を身につけ、長く活かせる技術者へと成長できる環境です。
                </span>
              </p>
            </div>
          </div>
          <div className="mt-4 md:flex">
            <StaticImage
              src="../../images/recruit/shin1.jpg"
              alt="製造職の現場"
              className="w-full"
            />
            <StaticImage
              src="../../images/recruit/shin2.jpg"
              alt="製造職の現場2"
              className="w-full"
            />
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">職務内容</h2>
          <div className="mt-8 ">
            <div className="mt-8 font-gothic">
              <ul className="list-inside list-disc pl-4">
                <li className="my-2"> 注文に応じた製作加工図の作成</li>
                <li className="my-2">
                  CAD CAMソフトを使用してNCプログラムの作成
                </li>
                <li className="my-2">
                  各加工機械を使用して切断加工、部品の組立作業
                </li>
                <li className="my-2">仕上げ、梱包出荷作業など</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">求める人物像</h2>
          <div className="mt-8 font-gothic">
            <ul className="list-inside list-disc pl-4">
              <li className="my-2">素直さと責任感を持ち合わせている方</li>
              <li className="my-2">ものづくりを仕事にされたい方</li>
            </ul>
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">待遇・制度</h2>
          <div className="mt-8 font-gothic">
            <div class="overflow-x-auto">
              <table class="min-w-full table-auto text-left">
                <tbody class="divide-y divide-transparent">
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      雇用形態
                    </th>
                    <td class="whitespace-nowrap py-2">
                      正社員（試用期間3ヶ月あり）
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      勤務地
                    </th>
                    <td class="whitespace-nowrap py-2">
                      愛知県 豊田市 百月町 井戸洞 58-1
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      勤務時間
                    </th>
                    <td class="whitespace-nowrap py-2">8:30〜17:30</td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      時間外労働
                    </th>
                    <td class="whitespace-nowrap py-2">
                      あり（納期に応じて / 36協定・法定割増に基づき支給）
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">給与</th>
                    <td class="whitespace-nowrap py-2">
                      初任給 月給220,000円（高卒）
                      <br />
                      初任給 月給260,000円（大卒）
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">賞与</th>
                    <td class="whitespace-nowrap py-2">
                      あり （24年度実績 年3回 計5ヶ月以上）
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">昇給</th>
                    <td class="whitespace-nowrap py-2">あり （年1回 5月）</td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      各種手当
                    </th>
                    <td class="whitespace-nowrap py-2">
                      役職手当 10,000~50,000円
                      <br />
                      業務手当 2,000~30,000円
                      <br />
                      地域手当 3,500円
                      <br />
                      扶養手当 配偶者 5,000円 こども 3,000円/人
                    </td>
                  </tr>
                  <tr class="align-top">
                    <th class="whitespace-nowrap py-2 pr-4 font-bold">
                      休日・休暇
                    </th>
                    <td class="whitespace-nowrap py-2">
                      年間休日
                      <span
                        className="text-red-600
                      "
                      >
                        125日
                      </span>
                      （25年度実績）
                      <br />
                      有給初年度10日（最大20日）
                      <br />
                      完全週休2日制（土日）、祝日、GW・夏季・年末年始、有給休暇、その他当社カレンダーによる
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">選考プロセス</h2>
          <div className="mt-8 font-gothic">
            <body>
              <div class="mx-auto">
                <div class="relative my-8">
                  <div class="inline-flex items-center">
                    <span class="inline-block h-4 w-4 rounded-full border border-primary"></span>
                    <span class="pl-4 text-sm text-primary">STEP 1</span>
                  </div>
                  <div class="pl-8">
                    <p class="mt-2 mb-2 font-bold">書類選考</p>
                    <span class="font-gothic">
                      履歴書を提出いただき、書類を確認いたします。
                    </span>
                  </div>
                  <span class="absolute left-2 top-4 z-[-1] h-[calc(100%+1em)] w-px bg-neutral last:hidden"></span>
                </div>

                <div class="relative my-8">
                  <div class="inline-flex items-center">
                    <span class="inline-block h-4 w-4 rounded-full border border-primary bg-white"></span>
                    <span class="pl-4 text-sm text-primary">STEP 2</span>
                  </div>
                  <div class="pl-8">
                    <p class="mt-2 mb-2 font-bold">面接</p>
                    <span class="font-gothic">
                      採用担当者との面接を行います。
                    </span>
                  </div>
                  <span class="absolute left-2 top-4 z-[-1] h-[calc(100%+1em)] w-px bg-neutral last:hidden"></span>
                </div>

                <div class="relative my-8">
                  <div class="inline-flex items-center">
                    <span class="inline-block h-4 w-4 rounded-full border border-primary ring-2 ring-inset ring-primarySupport"></span>
                    <span class="pl-4 text-sm text-primary">STEP 3</span>
                  </div>
                  <div class="pl-8">
                    <p class="mt-2 mb-2 font-bold">内定</p>
                    <span class="font-gothic">
                      最終結果をご連絡し、内定をお知らせします。
                    </span>
                  </div>
                  <span class="absolute left-2 top-4 z-[-1] h-[calc(100%+1em)] w-px bg-neutral last:hidden"></span>
                </div>
              </div>
            </body>
          </div>
        </div>
        <div className="pt-32 lg:mt-16 lg:pt-0">
          <h2 className="font-mincho text-3xl text-primary">応募方法</h2>
          <div className="mt-8 font-gothic">
            <p className="font-gothic leading-loose">
              <Link to="/contact" className="underline underline-offset-2">
                お問い合わせフォーム
              </Link>
              よりお名前、ご連絡先を記入の上、「新卒採用について」とお問い合わせください。
              <br />
              担当者より折り返しご連絡いたします。
            </p>
          </div>
        </div>
      </section>
    </div>
  </Layout>
)

export default Construct
